// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608100808/js/" + chunkId + "." + {"44":"c63c43a3","225":"0ffbf874","481":"9b16ea64","486":"d04f3aa2","770":"98c34175"}[chunkId] + ".0.989320934449939.chunk.js";
};